import { areAllElementsIn } from '../../utils';
/**
 * {
      "TP9nW1Pz6YEJlQ2Bus8YqVsG8fdB8oXs8zF1QCk6Fho=|u+MEX51NnOEfQMygFK6GPVsG8fdB8oXs8zF1QCk6Fho=": {
          "qryIdList": ["TP9nW1Pz6YEJlQ2Bus8YqVsG8fdB8oXs8zF1QCk6Fho=","u+MEX51NnOEfQMygFK6GPVsG8fdB8oXs8zF1QCk6Fho="],
          "data": {}
      }
    }
 */
const GOODS_ITEM_CACHE_KEY = 'GOODS_ITEM_CACHE_KEY';
function saveCacheToSessionStorage(cacheData) {
    try {
        const serializedData = JSON.stringify(cacheData);
        sessionStorage.setItem(GOODS_ITEM_CACHE_KEY, serializedData);
    }
    catch (error) {
        console.error('Failed to save cache to sessionStorage:', error);
    }
}
function loadCacheFromSessionStorage() {
    try {
        const serializedData = sessionStorage.getItem(GOODS_ITEM_CACHE_KEY);
        return serializedData ? JSON.parse(serializedData) : null;
    }
    catch (error) {
        console.error('Failed to load cache from sessionStorage:', error);
        return null;
    }
}
/** 设置缓存 */
export function cacheGoodsInfo(qryIdList, data) {
    if (!qryIdList.length)
        return;
    // 如果缓存已经有了，则不再进行设置
    const cacheData = getCacheGoodsInfo(qryIdList);
    if (cacheData)
        return;
    if (!(data === null || data === void 0 ? void 0 : data.length))
        return;
    // 否则，设置缓存
    const key = qryIdList.join('|');
    const goodsInfoCacheData = loadCacheFromSessionStorage();
    saveCacheToSessionStorage(Object.assign(Object.assign({}, goodsInfoCacheData), { [key]: { qryIdList, data } }));
}
/** 清除缓存 */
export function clearGoodsInfo() {
    sessionStorage.removeItem(GOODS_ITEM_CACHE_KEY);
}
/** 获取缓存 */
export function getCacheGoodsInfo(qryIdList) {
    const goodsInfoCacheData = loadCacheFromSessionStorage();
    if (!goodsInfoCacheData)
        return null;
    for (const value of Object.values(goodsInfoCacheData)) {
        if (areAllElementsIn(qryIdList, value.qryIdList)) {
            return value === null || value === void 0 ? void 0 : value.data;
        }
    }
    return null;
}
